import styled, { css } from 'styled-components';
import { ButtonTag } from '../Button/styles';

export const Info = styled.div`
  padding: 10px;

  @media(min-width: 768px) {
    padding: 15px;
  }
`;

export const Container = styled.article`
  width: ${({ multi }) => multi ? '215px' : '100%'};

  border-radius: 6px;
  box-shadow: ${({ multi }) => multi ? '0px 12px 48px rgba(0, 0, 0, 0.06)' : 'none'};

  overflow: hidden;
  margin: 0 auto;
  padding-top: 0;
  margin-bottom: 15px;

  @media(min-width: 768px) {
    width: 410px;
    margin-top: 25px;
  }
`;
export const ImageWrapper = styled.div`
  width: 100%;
  height: 150px;
  display: inline-block;

  border-radius: ${({ multi }) => multi ? '6px 6px 0 0' : '6px'};
  position: relative;

  @media(min-width: 768px) {
    height: 200px;
  }

  &::before {
    content: '${({ extra }) => `$${extra === null ? '0.00' : Math.abs(extra).toFixed(2)} ${extra > 0 ? 'MORE' : 'LESS'} `}';
    font-size: 12px;
    font-weight: bold;
    color: ${({ theme }) => theme.white};

    background-color: ${({ theme }) => theme.red};
    border-bottom-right-radius: 6px;
    filter: blur(${({ blur }) => blur ? '2px' : 0});

    padding: 7px 25px;

    position: absolute;
    top: 0;
    left: 0;

    @media(min-width: 768px) {
      font-size: 16px;
    }
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  display: inline-block;
`;

export const ProductHeader = styled.h2`
  font-size: 17px;
  margin: 0 auto;
  text-align: left;

  span {
    font-weight: normal;
    @media(min-width: 768px) {
      margin-left: 5px;
    }
  }

  @media(min-width: 768px) {
    font-size: 22px;
  }
`;

export const ListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .scrollList {
    padding-top: 10px;
    width: 100%;
    height: 150px;
    overflow: auto;
    text-align: left;
  }
  ul {

    flex-basis: 100%;

    @media(max-width: 768px) {
      overflow-y: auto;
    }

    @media(min-width: 768px) {
      flex-basis: ${({ multi }) => multi ? '50%' : '100%'};
    }

    li {
      font-size: 12px;
      text-align: left;
      margin-left: 20px;

      & > * {
        color: inherit !important;
        font: inherit !important;
      }

      @media(min-width: 768px) {
        font-size: 16px;
        margin-left: 25px;
      }

      &:not(:first-child) {
        margin-top: 10px;
      }

      position: relative;

      ${({ multi }) => multi && css`
        &:before {
          content: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 6.71429L5.2 11L15 1' stroke='%231EB6FF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
          position: absolute;
          transform: translateX(-150%);

          @media(min-width: 768px) {
            content: url("data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 6.71429L5.2 11L15 1' stroke='%231EB6FF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
          }
        }
      `}

      ${({ multi }) => !multi && css`
        &:before {
          content: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 6.71429L5.2 11L15 1' stroke='%231EB6FF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
          position: absolute;
          transform: translateX(-150%);

          @media(min-width: 768px) {           
            content: url("data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 6.71429L5.2 11L15 1' stroke='%231EB6FF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
          }
        }
      `}
    }
  }
`;

export const More = styled.button`
  font-size: 12px;
  color: ${({ theme }) => theme.blue};

  flex-basis: 100%;
  text-align: left;

  margin-left: 20px;

  @media(min-width: 768px) {
    margin-top: 0px;
    margin-left: 25px;
  }

  &:after {
    content: url("data:image/svg+xml,%3Csvg width='9' height='6' viewBox='0 0 9 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8 5L4.5 2L1 5' stroke='%231EB6FF' stroke-width='2'/%3E%3C/svg%3E");
    display: inline-block;
    margin-left: 5px;
    transform: rotate(${({ isOpened }) => isOpened ? '0' : '180deg'});
  }
`;

export const UpgradeButton = styled(ButtonTag)`
  align-self: flex-end;

  width: ${({ upgradeList }) => upgradeList ? '' : '100%'};

  margin-left: auto;
  padding: ${({ multi }) => multi ? '12px 23px' : '17px 80px'};
  margin-top: ${({ multi }) => multi ? '0px' : '16px'};
  margin-right: ${({ multi }) => multi ? '' : 'auto'};

  @media(min-width: 768px) {
    padding: ${({ multi }) => multi ? '17px 35px' : '17px 85px'};
  }
`;
